

































































































































































































import Component from 'vue-class-component';
import BaseComponent from '@/core/base.component';
import { NanudaUserDto, NanudaUserListDto } from '@/dto';
import NanudaUserService from '../../../services/nanuda-user.service';
import { CONST_YN, Pagination, YN } from '@/common';
import { BaseUser } from '@/services/shared/auth';
import toast from '../../../../resources/assets/js/services/toast.js';
import {
  ClearOutQueryParamMapper,
  ReverseQueryParamMapper,
  RouterQueryParamMapper,
} from '@/core';

@Component({
  name: 'NanudaUserList',
})
export default class NanudaUserList extends BaseComponent {
  private nanudaUserList: NanudaUserDto[] = [];
  private nanudaUserTotalCount = 0;
  private nanudaUserSearchDto = new NanudaUserListDto();
  private nanudaUserCreateDto = new NanudaUserDto(BaseUser);
  private pagination = new Pagination();
  private dataLoading = false;
  private yn: YN[] = [...CONST_YN];
  private searchQueryParamsDto: any = {};

  // find All Nanuda user
  findAll(isPagination?: boolean, isSearch?: boolean) {
    this.dataLoading = true;
    if (!isPagination) {
      this.pagination.page = 1;
    } else {
      if (isSearch) this.pagination.page = 1;
      RouterQueryParamMapper(this.nanudaUserSearchDto, this.pagination);
    }
    NanudaUserService.findAll(
      this.nanudaUserSearchDto,
      this.pagination,
    ).subscribe(res => {
      if (res) {
        this.dataLoading = false;
        this.nanudaUserList = res.data.items;
        this.nanudaUserTotalCount = res.data.totalCount;
      }
    });
  }

  // search nanuda user
  search() {
    this.findAll(true, true);
  }

  // clearout search dto
  clearOut() {
    if (location.search) {
      ClearOutQueryParamMapper();
    } else {
      this.nanudaUserSearchDto = new NanudaUserListDto();
      this.findAll();
    }
  }

  // pagination
  paginateSearch() {
    this.findAll(true);
  }

  // create nanuda user
  createUser() {
    NanudaUserService.create(this.nanudaUserCreateDto).subscribe(res => {
      if (res) {
        toast.success('추가완료');
        this.clearOut();
        this.$bvModal.hide('add_user');
      }
    });
  }

  // clearout create dto
  clearOutCreateDto() {
    this.nanudaUserCreateDto = new NanudaUserDto(BaseUser);
    this.$bvModal.hide('add_user');
  }

  created() {
    const query = ReverseQueryParamMapper(location.search);
    if (query) {
      this.nanudaUserSearchDto = query;
      if (!isNaN(+query.limit) && !isNaN(+query.page)) {
        this.pagination.limit = +query.limit;
        this.pagination.page = +query.page;
      } else {
        this.pagination = new Pagination();
      }
      this.paginateSearch();
    } else {
      this.findAll();
    }
  }
}
